import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import HomeValueEstimator from "@/pages/HomeValueEstimator";

export const Route = createFileRoute("/home-value")({
  head: () => seoHead("/home-value"),
  component: HomeValueEstimator,
});
